import * as React from "react";
import {formatSvgString, getSize, IconProps, SystemIcon} from "../index";
import SVG from "react-inlinesvg";
import {SystemIcons as SI} from "@laerdal/figma-svg";

export const ChevronLeft: React.FunctionComponent<IconProps> = ({
                                                                  className,
                                                                  color = 'currentColor',
                                                                  size = '24px',
                                                                  label = '',
                                                                  viewBox = '0 0 24 24', ...rest
                                                                }) => (
  <SystemIcon tooltip={label}>
    <SVG src={SI.ChevronLeft} height={getSize(size)} width={getSize(size)} {...rest} className={className} viewBox={viewBox}
         preProcessor={content => formatSvgString(content, color)}/>
  </SystemIcon>
);
